import React from 'react'
import HeroSection from '../components/HeroSection'
import Collection from '../components/Collection'
// import Review from '../components/Review'
import Footer from '../components/Footer'
import NewRelease from '../components/NewRelease'
import AddCollectionForm from '../components/AddCollectionForm'
import FeaturedProducts from '../components/FeaturedProducts'
import { useCollections } from '../hooks/useCollection';

export default function Home() {
  const { collections, loading } = useCollections('collections');
  
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner-overlay">
        <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <main>
        {/* Hero */}
      <HeroSection />
      {/* Collections */}
      <Collection collections={collections} />
      <AddCollectionForm />
      <br />
      {/* Qoutes  */}
      <NewRelease />
      {/* Products */}
      <FeaturedProducts />
      {/* Review */}
      {/* <Review /> */}
      {/* Footer */}
      <Footer />
      </main>
    </div>
  )
}
